import React from 'react';
import DownloadAppPage from './DownloadAppPage';

const Download = () => <DownloadAppPage />;

export default Download;
